function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconsFilterFitnessPlayerLength = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-258f82e3-2bf8-4c20-899c-6d480b0508e6",
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M28.75,11.72c.24,1.04,.37,2.13,.37,3.24,0,7.8-6.32,14.12-14.12,14.12S.88,22.77,.88,14.97,7.2,.84,15,.84c3.36,0,6.44,1.17,8.86,3.13",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.68px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3,5.86c-.22-.07-.4-.24-.48-.47-.13-.38,.08-.8,.46-.92l1.61-.53-.53-1.61c-.13-.38,.08-.8,.46-.92,.38-.13,.8,.08,.92,.46l.76,2.3c.13,.38-.08,.8-.46,.92l-2.3,.76c-.15,.05-.3,.05-.44,0Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "15 5.02 15 16.31 19.94 19.38",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.68px"
    }
  }));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconsFilterFitnessPlayerLength, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Icons_Filter_FitnessPlayer_Length.cdbd00a6.svg";
export { ForwardRef as ReactComponent };